import BankAccountRequestField from "./BankAccountRequestField";

export default class BankAccountRequestDTO {

    constructor(jsonResponse) {
        this.id = jsonResponse["id"];
        this.registrationId = jsonResponse["registration-id"];
        this.dateCreated = jsonResponse["date-created"];
        this.creationAgentId = jsonResponse["creation-agent-id"];
        this.status = jsonResponse["status"];

        this.extraFields = [];

        let jsonExtraFields = jsonResponse["extra-fields"];

        jsonExtraFields.forEach(extraField => {
            this.extraFields.push(new BankAccountRequestField(extraField));
        });
    }
}
